import { IconProps } from "./Icon.model";

export function Alert02Icon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.90845 1.3429C7.61789 1.10752 8.38261 1.10745 9.09204 1.3429C9.79874 1.57748 10.3539 2.13445 10.9114 2.91614C11.4669 3.69522 12.081 4.78162 12.8723 6.18176L12.9026 6.23645C13.6941 7.63695 14.3081 8.7237 14.6907 9.60461C15.0751 10.4898 15.2673 11.2542 15.1145 11.9884C14.9607 12.7275 14.5808 13.3993 14.0286 13.9073C13.4775 14.4142 12.7272 14.6289 11.7825 14.7316C10.8431 14.8337 9.61409 14.8331 8.03247 14.8331H7.96802C6.38661 14.8331 5.15738 14.8337 4.21802 14.7316C3.27325 14.6289 2.52297 14.4142 1.97192 13.9073C1.4196 13.3993 1.03984 12.7276 0.885986 11.9884C0.733237 11.2542 0.924505 10.4897 1.30884 9.60461C1.69141 8.7237 2.30544 7.63696 3.09692 6.23645L3.12817 6.18176L3.69067 5.19055C4.22323 4.25776 4.67242 3.50047 5.08911 2.91614C5.64655 2.13445 6.20175 1.57748 6.90845 1.3429ZM7.99731 10.6671C7.63084 10.6671 7.33337 10.965 7.33325 11.3331C7.33325 11.7013 7.63077 12.0001 7.99731 12.0001H8.00317C8.36965 12 8.66626 11.7013 8.66626 11.3331C8.66615 10.9651 8.36958 10.6672 8.00317 10.6671H7.99731ZM8.00024 5.33313C7.63205 5.33313 7.33325 5.63193 7.33325 6.00012V8.66711C7.33349 9.0351 7.6322 9.33313 8.00024 9.33313C8.3682 9.33302 8.66602 9.03504 8.66626 8.66711V6.00012C8.66626 5.632 8.36834 5.33324 8.00024 5.33313Z"
        fill={fillColor}
      />
    </svg>
  );
}

